import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { setFinalWinner } from 'slices/finalWinnerSlice';
import { postalCode, removeErrorCP, setErrorCP } from 'slices/postalCodeSlice';
import AlertDanger from 'components/alert/AlertDanger';
import FormSidebar from 'components/formSidebar';
import Lottie from 'lottie-react-web';
import * as Yup from 'yup';
import { MEMBER_URL, SUBASTAS_URL } from '../../constants/Constants';
import cpLoader from '../../assets/cp-loader.json';

const FormProduct = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  const decodeUTF8 = (str) => {
    return decodeURIComponent(escape(window.atob(str)));
  };

  const auction = decodeUTF8(searchParams.get('title'));

  const auctionEncoded = searchParams.get('title');
  const auctionId = atob(searchParams.get('auctionId'));

  const nameURL = searchParams.get('name');
  const auctionURL = searchParams.get('title');
  const rewardTypeURL = searchParams.get('rewardType');
  const auctionIdURL = searchParams.get('auctionId');
  const rewardType = atob(searchParams.get('rewardType'));

  const UserSchema = Yup.object().shape({
    nameForm: Yup.string().required('* Campo requerido').matches(/^[a-zA-Zá-ú]/, 'Solo letras y espacios'),
    lastNameForm: Yup.string().required('* Campo requerido').matches(/^[a-zA-Zá-ú]/, 'Solo letras y espacios'),
    maternalSurnameForm: Yup.string().required('* Campo requerido').matches(/^[a-zA-Zá-ú]/, 'Solo letras y espacios'),
    mailForm: Yup.string().required('* Campo requerido').email('* Email no válido'),
    phoneForm: Yup.string().required('* Campo requerido').matches(/^[0-9]{10}$/, '* Teléfono no válido'),
    postalCodeForm: Yup.string().required('* Campo requerido').matches(/^[0-9]{5}$/, '* Código postal no válido'),
    stateForm: Yup.string().required('* Campo requerido').matches(/^[a-zA-Zá-úÁ-Ú]/, 'Solo letras y espacios'),
    townForm: Yup.string().required('* Campo requerido').matches(/^[a-zA-Zá-úÁ-Ú]/, 'Solo letras y espacios'),
    cityForm: Yup.string().required('* Campo requerido').matches(/^[a-zA-Zá-úÁ-Ú]/, 'Solo letras y espacios'),
    streetForm: Yup.string().required('* Campo requerido').matches(/^[a-zA-Z0-9\s]+$/, 'Sin caracteres especiales'),
    externalNumberForm: Yup.string().required('* Campo requerido').matches(/^[a-zA-Z0-9]{1,5}$/, '* Número exterior no válido'),
    internalNumberForm: Yup.string().matches(/^[a-zA-Z0-9]{1,5}$/, '* Número interior no válido'),
    suburbForm: Yup.string().required('* Campo requerido'),
    otherSuburbForm: Yup.string().when('suburbForm', {
      is: 'Otra',
      then: Yup.string().required('* Campo requerido').matches(/^[a-zA-Zá-ú\s]+$/, 'Sin caracteres especiales'),
    }),
  });

  const { name, lastName, middleName, phoneNumber, email,
    address } = useSelector((state) => state.user.user);

  const initialValues = {
    nameForm: '',
    lastNameForm: '',
    maternalSurnameForm: '',
    mailForm: '',
    phoneForm: '',
    postalCodeForm: '',
    stateForm: '',
    townForm: '',
    cityForm: '',
    suburbForm: '',
    streetForm: '',
    externalNumberForm: '',
    internalNumberForm: '',
  };

  const savedValues = {
    nameForm: name,
    lastNameForm: lastName,
    maternalSurnameForm: middleName,
    mailForm: email,
    phoneForm: phoneNumber,
    postalCodeForm: address.postalCode,
    stateForm: address.state,
    townForm: address.country,
    cityForm: address.city,
    suburbForm: address.colony,
    streetForm: address.street,
    externalNumberForm: address.extNumber,
    internalNumberForm: address.intNumber,
  };

  const [formValues, SetFormValues] = useState(initialValues);
  const [chekInput, SetChekInput] = useState(false);
  const [check, setCheck] = useState(false);
  const { error } = useSelector((state) => state.finalWinner.winner);
  const { statusDataWinner } = useSelector((state) => state.finalWinner);
  const { errorCP } = useSelector((state) => state.cp);
  const [selectSuburb, setSelectSuburb] = useState([]);

  const SavedGetPostalCode = async (postalCodeAPI, setFieldValue) => {
    const resp = await dispatch(postalCode(postalCodeAPI));
    const data = resp.payload;
    if (data === undefined) {
      dispatch(setErrorCP());
    } else if (data.length > 0) {
      const suburb = data.map((m) => m.colony);
      setSelectSuburb(suburb);
      setFieldValue('suburbForm', suburb[0]);
    }
  };

  const InitialGetPostalCode = async (cp, setFieldValue) => {
    const resp = await dispatch(postalCode(cp));
    const data = resp.payload;
    if (data === undefined) {
      dispatch(setErrorCP());
    } else if (data.length > 0) {
      dispatch(removeErrorCP());
      const suburb = data.map((m) => m.colony);
      setSelectSuburb(suburb);
      setFieldValue('stateForm', data[0].state);
      setFieldValue('townForm', data[0].delegation);
      setFieldValue('cityForm', data[0].town);
      setFieldValue('suburbForm', suburb[0]);
    }
  };

  const apiClic = () => {
    setCheck(!check);
    if (check) {
      SetFormValues(savedValues);
      SetChekInput(true);
    } else {
      setSelectSuburb([]);
      SetFormValues(initialValues);
      SetChekInput(false);
    }
  };

  useEffect(() => {
    apiClic();
  }, []);

  const apiSetValues = (setFieldValue) => {
    apiClic();
    SavedGetPostalCode(savedValues.postalCodeForm, setFieldValue);
  };

  useEffect(() => {
    if (error === false) {
      navigate(`/subastas-ganador-final?title=${auctionEncoded}&rewardType=${rewardTypeURL}`);
    }
  }, [error]);

  const handleLogin = () => {
    Cookies.set('redirect', `subastas-ganador/?name=${nameURL}&title=${auctionURL}&rewardType=${rewardTypeURL}&auctionId=${auctionIdURL}`);
    window.location = `${MEMBER_URL}/login?url=${SUBASTAS_URL}/#/subastas-ganador`;
  };

  const sendData = async (valores) => {
    const { nameForm, lastNameForm, maternalSurnameForm, mailForm, phoneForm,
      postalCodeForm, stateForm, townForm, cityForm, streetForm, suburbForm, otherSuburbForm,
      internalNumberForm, externalNumberForm } = valores;
    const dataFormWinner = {
      auctionId,
      info: [
        {
          passengerNumber: 1,
          name: nameForm,
          lastName: lastNameForm,
          maternalSurname: maternalSurnameForm,
          mail: mailForm,
          phone: phoneForm,
          postalCode: postalCodeForm,
          state: stateForm,
          town: townForm,
          city: cityForm,
          suburb: suburbForm === 'Otra' ? otherSuburbForm : suburbForm,
          street: streetForm,
          internalNumber: internalNumberForm,
          externalNumber: externalNumberForm,
          birthDate: null,
          goingDate: null,
          returnDate: null,
          passport: null,
        },
      ],
    };

    const resp = await dispatch(setFinalWinner(dataFormWinner));

    if (resp.payload.status === 403) {
      handleLogin();
    }
  };

  const { message } = useSelector((state) => state.finalWinner.winner);

  return (
    <div className="bg-white">
      <Container className="py-60">
        <Row className="ml-md-5">
          <Col md={8} className="ml-md-3 order-2 order-md-1">
            <h2 className="mb-4">
              {`¡Felicidades ${name} eres el ganador de la Subasta!`}
            </h2>

            {error && (
              <AlertDanger
                heading="¡Lo sentimos!"
                body={message}
                type="General" />
            )}

            <Formik
              initialValues={formValues}
              validationSchema={UserSchema}
              enableReinitialize
              validateOnMount
              onSubmit={async (valores) => {
                sendData(valores);
              }}>
              {({ values, setFieldValue }) => {
                return (
                  <Form>
                    <div className="p-3 bdr-2 border">
                      <Row>
                        <Col xs={12}>
                          <p className="lh-24 text-tangaroa">Ingresa los datos solicitados. Una vez completados, haz clic en el botón ‘Enviar’ y pronto nos contactaremos contigo para hacer entrega de tu premio.</p>
                        </Col>

                        <Col md={12}>
                          <button
                            type="button"
                            className="custom-checkbox my-3 btn-link"
                            onClick={() => apiSetValues(setFieldValue)}>
                            <Field
                              type="checkbox"
                              checked={chekInput}
                              className="custom-control-input"
                              name="api"
                              placeholder="Ingresa tu Número de Cuenta" />
                            <label htmlFor="check" className="custom-control-label text-left text-tangaroa">Utilizar datos registrados en Aeroméxico Rewards</label>
                          </button>
                        </Col>

                        <Col xs={12}>
                          <h3 className="text-tangaroa">Datos personales</h3>
                        </Col>

                        <Col md={6}>
                          <div className="custom-control">
                            <label htmlFor="nameForm">Nombre(s) *</label>
                            <Field
                              className="form-control"
                              type="text"
                              name="nameForm" />
                          </div>
                          <div className="mb-1">
                            <small className="text-error">
                              <ErrorMessage name="nameForm" />
                            </small>
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="custom-control">
                            <label htmlFor="lastNameForm">Apellido Paterno *</label>
                            <Field
                              className="form-control"
                              type="text"
                              name="lastNameForm" />
                          </div>
                          <div className="mb-1">
                            <small className="text-error">
                              <ErrorMessage name="lastNameForm" />
                            </small>
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="custom-control">
                            <label htmlFor="maternalSurnameForm">Apellido Materno *</label>
                            <Field
                              className="form-control"
                              type="text"
                              name="maternalSurnameForm" />
                          </div>
                          <div className="mb-1">
                            <small className="text-error">
                              <ErrorMessage name="maternalSurnameForm" />
                            </small>
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="custom-control">
                            <label htmlFor="mailForm">Correo electrónico *</label>
                            <Field
                              className="form-control"
                              type="mail"
                              name="mailForm" />
                          </div>
                          <div className="mb-1">
                            <small className="text-error">
                              <ErrorMessage name="mailForm" />
                            </small>
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="custom-control">
                            <label htmlFor="phoneForm">Teléfono *</label>
                            <Field
                              className="form-control"
                              type="tel"
                              name="phoneForm" />
                          </div>
                          <div className="mb-1">
                            <small className="text-error">
                              <ErrorMessage name="phoneForm" />
                            </small>
                          </div>
                        </Col>
                      </Row>

                      <Row>

                        <Col xs={12} className="mt-30">
                          <h3 className="text-tangaroa">Dirección</h3>
                          {errorCP && (
                            <AlertDanger
                              heading="¡Lo sentimos!"
                              body="El código postal ingresado no se encuentra dentro
                              de nuestra cobertura. Por favor intenta con otro."
                              type="postalCode" />
                          )}
                        </Col>

                        <Col md={6}>
                          <div className="custom-control">
                            <label htmlFor="postalCodeForm">Código Postal *</label>
                            <Field
                              className="form-control"
                              autoComplete="nope"
                              type="text"
                              onBlur={() => InitialGetPostalCode(values.postalCodeForm,
                                setFieldValue)}
                              name="postalCodeForm" />
                          </div>
                          <div className="mb-1">
                            <small className="text-error">
                              <ErrorMessage name="postalCodeForm" />
                            </small>
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="custom-control">
                            <label htmlFor="stateForm">Estado *</label>
                            <Field
                              className="form-control"
                              type="text"
                              name="stateForm" />
                          </div>
                          <div className="mb-1">
                            <small className="text-error">
                              <ErrorMessage name="stateForm" />
                            </small>
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="custom-control">
                            <label htmlFor="cityForm">Ciudad *</label>
                            <Field
                              className="form-control"
                              type="text"
                              name="cityForm" />
                          </div>
                          <div className="mb-1">
                            <small className="text-error">
                              <ErrorMessage name="cityForm" />
                            </small>
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="custom-control">
                            <label htmlFor="townForm">Municipio o Delegación *</label>
                            <Field
                              className="form-control"
                              type="text"
                              name="townForm" />
                          </div>
                          <div className="mb-1">
                            <small className="text-error">
                              <ErrorMessage name="townForm" />
                            </small>
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="custom-select-cp">
                            <label htmlFor="suburbForm">Colonia *</label>
                            <Field
                              as="select"
                              name="suburbForm"
                              className="custom-select">
                              {values.suburbForm === '' && (<option value="">Selecciona una Colonia</option>)}

                              {selectSuburb.length > 0 && (
                                selectSuburb.map((s) => (
                                  <option key={s} value={s}>{s}</option>
                                ))
                              )}
                              <option value="Otra">Otra</option>
                            </Field>
                          </div>
                          <div className="mb-1">
                            <small className="text-error">
                              <ErrorMessage name="suburbForm" />
                            </small>
                          </div>
                        </Col>
                        {values.suburbForm === 'Otra' && (
                          <Col md={6}>
                            <div className="custom-control">
                              <label htmlFor="otherSuburbForm">Ingresa la Colonia *</label>
                              <Field
                                className="form-control"
                                type="text"
                                required
                                name="otherSuburbForm" />
                            </div>
                            <div className="mb-1">
                              <small className="text-error">
                                <ErrorMessage name="otherSuburbForm" />
                              </small>
                            </div>
                          </Col>
                        )}

                        <Col md={6}>
                          <div className="custom-control">
                            <label htmlFor="streetForm">Calle *</label>
                            <Field
                              className="form-control"
                              type="text"
                              name="streetForm" />
                          </div>
                          <div className="mb-1">
                            <small className="text-error">
                              <ErrorMessage name="streetForm" />
                            </small>
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="custom-control">
                            <label htmlFor="externalNumberForm">No. Exterior *</label>
                            <Field
                              className="form-control"
                              type="text"
                              name="externalNumberForm" />
                          </div>
                          <div className="mb-1">
                            <small className="text-error">
                              <ErrorMessage name="externalNumberForm" />
                            </small>
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="custom-control">
                            <label htmlFor="internalNumberForm">No. Interior</label>
                            <Field
                              className="form-control"
                              type="text"
                              name="internalNumberForm" />
                          </div>
                          <div className="mb-1">
                            <small className="text-error">
                              <ErrorMessage name="internalNumberForm" />
                            </small>
                          </div>
                        </Col>
                      </Row>
                    </div>

                    {statusDataWinner === 'loading' ? (
                      <div className="d-flex justify-content-end mt-3">
                        <Lottie
                          width={60}
                          options={{
                            animationData: cpLoader,
                          }} />
                      </div>
                    ) : (
                      <div className="d-flex justify-content-end mt-3">
                        <Button variant="primary" type="submit">Enviar</Button>
                      </div>
                    )}
                  </Form>
                );
              }}
            </Formik>
          </Col>
          <Col md={3} className="order-1 order-md-2 mb-1 mb-md-0">
            <FormSidebar auction={auction} type={rewardType} />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default FormProduct;
